import {
  Divider,
  Illustration,
  type IllustrationType,
  Text,
} from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export interface IllustrationListItemProps {
  illustrationType: IllustrationType;
  title: string;
  description: string;
  divider?: boolean;
}

export function IllustrationListItem(props: IllustrationListItemProps) {
  const { illustrationType, title, description, divider = false } = props;

  return (
    <Stack>
      <Stack direction="row" spacing={5} sx={(theme) => ({ paddingY: theme.spacing(6) })}>
        <Illustration type={illustrationType} />
        <Stack spacing={2}>
          <Text semibold variant="body1">
            {title}
          </Text>
          <Text semibold variant="caption" sx={(theme) => ({ color: theme.palette.text.tertiary })}>
            {description}
          </Text>
        </Stack>
      </Stack>
      {divider && <Divider sx={(theme) => ({ marginY: theme.spacing(1) })} />}
    </Stack>
  );
}
